<template lang='pug'>
  IMListCC(:title='title' :listType='listType' :dialogType="dialogType" :im='getIM()')
</template>

<script>
import IMListCC from "../components/IMListCC.vue";
import * as i18n from "../data/i18n.json";
export default {
  name: "MyCC",
  components: {
    IMListCC
  },
  data() {
    return {
      i18n: i18n.default,
      title: "Carbon Copy Page",
      listType: "user",
      dialogType: "user",
      im: {
        headers: [
          {
            text: "IM Number",
            value: "imNo"
          },
          {
            text: "Subject",
            value: "imPerihal"
          },
          {
            text: "Category",
            value: "imCategory"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
          }
        ],
        items: [],
        bisnisUnit: '',
        paymentHeaders: [
          {
            text: "IM Number",
            value: "imNo",
            width: '14%',
          },
          {
            text: "Subject",
            value: "imPerihal",
            width: '30%',
          },
          {
            text: "Category",
            value: "imCategory"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
            width: '12%',
          }
        ],
      }
    }
  },
  mounted() {
    // this.$store.dispatch("fetchDataCC");
  },
  methods: {
    getIM() {
      this.im.items = this.$store.state.dataReqCC.data;
      this.im.jumlah = this.$store.state.dataReqCC.jumlah;
      if(this.im.items){
        for (let i = 0; i < this.im.items.length; i++) {
          this.im.items[i].imStatusLabel = this.i18n.status[
            this.im.items[i].imStatus
          ].name;
          this.im.items[i].imTypeLabel = this.i18n.imType[
            this.im.items[i].imType
          ];

          if ( this.im.items[i].hasOwnProperty('imCategory') ) {
            for( const data of this.i18n.category ) {
              if ( data.value == this.im.items[i].imCategory ) {
                this.im.items[i].imCategory = data.text
              }
            }
          } else if (this.im.items[i].imType == 6 || this.im.items[i].imType == 7) {
            this.im.items[i].imCategory = "N/A"
          } else {
            this.im.items[i].imCategory = "General"
          }
        }
      }
      return this.im;
    },
  }
};
</script>
